export default __webpack_public_path__ + "static/media/45.e33eb125.png";